<template>
  <v-menu
    offset-y
    transition="slide-x-transition"
    bottom
    max-width="450"
    :nudge-bottom="$vuetify.breakpoint.mdAndUp ? 9 : 5"
  >
    <template #activator="{ on }">
      <v-btn
        class="mr-0"
        icon
        v-on="on"
      >
        <v-avatar
          size="40"
          style="border: 1px solid #c1c1c1;"
          :color="!user.profile_image ? 'primary lighten-1' : ''"
        >
          <v-img
            v-if="user.profile_image"
            :src="user.profile_image"
            :lazy-src="user.profile_image"
            alt="Profile"
          >
            <template #placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>

          <span
            v-else
            class="white--text subtitle-1"
          >
            {{ initials }}
          </span>
        </v-avatar>
      </v-btn>
    </template>

    <v-card>
      <v-list-item
        class="align-start py-1"
      >
        <div class="pt-4">
          <v-avatar
            size="75"
            style="border: 1px solid #c1c1c1;"
            :color="!user.profile_image ? 'primary lighten-1' : ''"
          >
            <v-img
              v-if="user.profile_image"
              :src="user.profile_image"
              :lazy-src="user.profile_image"
              alt="Profile"
            >
              <template #placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  />
                </v-row>
              </template>
            </v-img>

            <span
              v-else
              class="white--text display-1"
            >
              {{ initials }}
            </span>
          </v-avatar>
        </div>

        <v-list-item-content>
          <v-list-item-title
            class="text-h5 pl-4"
          >
            <span v-if="user.full_name">
              {{ user.full_name }}
            </span>
            <span v-else>
              {{ user.first_name }} {{ user.last_name }}
            </span>
          </v-list-item-title>
          <v-list-item-subtitle
            class="pl-4"
          >
            {{ user.email }}
          </v-list-item-subtitle>

          <div>
            <v-btn
              v-if="user"
              class="justify-start"
              text
              @click="clickManage"
            >
              Manage my account
            </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <div
        class="py-2 px-4 d-flex justify-end"
        @click.stop="() => { return true; }"
      >
        <v-switch
          v-model="darkMode"
          class="ma-0"
          :color="darkMode ? 'indigo' : null"
          :label="`Dark mode`"
          hide-details
          dense
        />
      </div>

      <v-divider />

      <v-card-actions>
        <v-btn
          text
          class="ml-auto"
          @click="clickLogout"
        >
          Logout
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'AccountMenu',

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    darkMode: {
      get() {
        return this.$store.state.displaySettings.darkMode;
      },
      set() {
        this.toggleDarkMode();
      },
    },

    initials() {
      if (!this.user.full_name && !this.user.first_name && !this.user.last_name) return 'X_X';

      let init1 = '';
      let init2 = '';
      if (this.user.full_name) {
        const list = this.user.full_name.split(' ');
        init1 = String(list[0].substring(0, 1).toUpperCase());
        init2 = String(list[1].substring(0, 1).toUpperCase());
      } else {
        if (this.user.first_name) {
          init1 = this.user.first_name[0].substring(0, 1).toUpperCase();
        }
        if (this.user.last_name) {
          init2 = this.user.last_name[0].substring(0, 1).toUpperCase();
        }
      }
      return `${init1} ${init2}`;
    },
  },

  methods: {
    ...mapMutations('displaySettings', [
      'toggleDarkMode',
    ]),

    ...mapMutations('account', [
      'logoutUser',
    ]),

    ...mapActions('account', [
      'logout',
    ]),

    async clickLogout() {
      try {
        await this.logout();
        window.location.href = process.env.VUE_APP_CAS_CLIENT;
      } catch (error) {
        console.log(error);
        // Than keep going logout process
        this.logoutUser();
        window.location.href = process.env.VUE_APP_CAS_CLIENT;
      }
    },

    clickManage() {
      window.open(`${process.env.VUE_APP_CAS_CLIENT}/settings`, '_self');
      // this.$router.push({ name: 'setting' });
    },
  },
};
</script>
